<template>
  <enfold>
    <div class="login-log">
      <enfold-ucd>
        <template slot="up">
          <div class="c-u-left">
            <!-- <el-tooltip class="item" effect="dark" :content="$t('log.export')" placement="top-start">
						<i class="icon"><div class="export" @click="exportExcel"></div></i>
						</el-tooltip> -->
            <el-button size="mini" round type="primary" icon="el-icon-document" @click="exportExcel">{{$t('log.export')}}</el-button>
            <div class="select">
              <!-- <el-select v-model="selectDate" @change="selectDevice" filterable :placeholder="$t('log.selectDevice')"
								v-loadmore="loadMore" style="width: 100%;" size="mini">
								<el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value" :disabled="item.disabled" :class="{fontred:item.disabled==true,fontgreen:item.disabled==false}">
								</el-option>
							</el-select> -->
              <device-list @selectDevice="selectDevice" :isDisabled="true"></device-list>
            </div>
            <div class="pick">
              <span style="font-size: 14px;">{{$t('log.dateArr')}}：</span>
              <el-date-picker v-model="startDate" value-format="timestamp" align="right" type="date" :placeholder="$t('log.startDate')" @change="startDateChange" size="mini">
              </el-date-picker>
              <span>——</span>
              <el-date-picker v-model="endDate" value-format="timestamp" align="right" type="date" :placeholder="$t('log.endDate')" @change="endDateChange" size="mini">
              </el-date-picker>
            </div>
            <div>
              <el-button type="primary" @click="searchByDate()" size="mini" round>{{$t('log.search')}}</el-button>
            </div>
          </div>
          <div class="c-u-right flex-b-c">
            <div class="search_input" style="width: 140px;margin-right: 16px;">
              <el-input v-model="search_id" placeholder="编号查询" size="mini">
                <i slot="suffix" class="el-icon-search icon" @click="searchId"></i>
              </el-input>
            </div>
            <div class="search_input">
              <el-input v-model="search_data" :placeholder="$t('review.enterKey')" size="mini">
                <i slot="suffix" class="el-icon-search icon" @click="search"></i>
              </el-input>
            </div>
            <!-- <div class="search_button" @click="search"></div> -->
          </div>
        </template>
        <template slot="center">
          <el-table :data="current_device_data" style="width: 100%" :empty-text="$t('log.searchTips')" v-loading="loading" :element-loading-text="$t('log.loadingTips')" height="100%">
            <el-table-column prop="_id" :label="$t('log.no')" width="80"></el-table-column>
            <el-table-column prop="TYPE" :label="$t('terminal.types')"></el-table-column>
            <el-table-column prop="CONTENT" :label="$t('log.content')"></el-table-column>
            <el-table-column prop="OPERATOR" :label="$t('log.operateObj')"></el-table-column>
            <el-table-column prop="OPERATOR_INFO" :label="$t('log.operateContent')"></el-table-column>
            <el-table-column prop="TIME" :label="$t('log.operateTime')" width="180">
            </el-table-column>
          </el-table>
        </template>
        <template slot="down">
          <pagination :current="current" :limit="limit" :page="current_page" @currentChange="currentChange"></pagination>
        </template>
      </enfold-ucd>
    </div>
    <export-dialog :exportDialogVisible="exportDialogVisible" type="terminal" :terminalStart="startDate" :terminalEnd="endDate" :logList="time_limit_log" @changeShow="showAdd">
    </export-dialog>
  </enfold>
</template>

<script>
import moment from 'moment';
//const year = 2020;
//const month = new Date().getMonth();
//const month = 4;
//const date = 31;
//const end_date = new Date(year,month,date)
const end_date = moment();
//console.log(moment(1629444163224).format('zz'))
//const start_date = month<=3 ? new Date(year - 1, 12 - (3 - month), date) : new Date(year, month-3, date);
const start_date = moment(end_date).add(-1, 'M');
const min_start_date = moment(end_date).add(-3, 'M');
import EnfoldUcd from "@/components/basics/EnfoldUCD"
import Enfold from "@/components/basics/Enfold"
import pagination from '@/components/basics/Pagination'
import ExportDialog from './children/ExportDialog.vue'
import DeviceList from './children/DeviceList'
//import FormDialog from '@/components/basics/FormDialog'
import {
  dateFormatting,
  timeFormatting
} from "@/assets/scripts/dateFormatting"
import {
  mPagination
} from "@/components/basics/mixins";
import {
  uriEncode
} from "@/assets/scripts/uriEncode";
export default {
  name: 'LoginlLog',
  mixins: [mPagination],
  components: {
    Enfold,
    EnfoldUcd,
    ExportDialog,
    pagination,
    DeviceList
    //FormDialog
  },
  data() {
    return {
      exportDialogVisible: false,
      loading: false,
      search_id: '',
      search_data: '',
      // options: [],
      startDate: start_date,
      endDate: end_date,
      minStartDate: min_start_date,
      deviceList: [],
      selectDate: null,
      device_total: 0,
      device_count: 0,
      current_page: 1,
      logList: null,
      selecetedDevice: {},
      device_info_listt: [],
      current_device_data: [],//当前页的列表
      time_limit_log: [],//查询的列表
      search_list: []//搜索出来的列表
      // export_date: [new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0),
      // 	new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59)
      // ]
    }
  },
  methods: {
    showAdd(data) {
      if (data === 'false') {
        this.exportDialogVisible = false
      } else {
        this.exportDialogVisible = true
      }
    },
    openFilterDialog() {
      this.msgDialogVisible = true;
    },
    closeDialog(isConfirm) {
      if (isConfirm) {
        //console.log("确定...")
      }
      this.msgDialogVisible = false;
    },
    startDateChange() {

    },
    endDateChange() {

    },
    selectDevice(val) {
      this.selectDate = val;
      this.device_info_listt.forEach((ele) => {
        if (ele.id == val) {
          this.selecetedDevice = ele;
          //this.getZlogList(ele);
        }
      })
    },
    searchId() {
      if (!this.search_id) { return; }

      let logItem = this.time_limit_log.find(log => log._id == this.search_id);
      if (!logItem) {
        this.$msg({ message: "未查询到!", type: 'warning' });
        return;
      }

      this.search_list = [];
      this.current_page = 1;
      if (this.time_limit_log.length < 12) {
        this.search_list = this.time_limit_log;
        return;
      }

      let indexId = logItem._id;

      if (indexId < 6) { indexId = 6; }
      this.time_limit_log.forEach(logItem => {
        const { _id } = logItem;
        ((indexId - 6) < _id) && (_id < (indexId + 7)) && this.search_list.push(logItem);
      });
      this.current = this.search_list.length;
      this.current_device_data = this.search_list.slice(0, this.limit);
      this.current_device_data.forEach((ele) => {
        ele.TIME = dateFormatting(new Date(ele.TIME)) + ' ' + timeFormatting(
          new Date(ele.TIME));
      });
      setTimeout(() => { this.search_id = ''; }, 10 * 1000);
    },
    search() {

      if (!this.search_data) { return; }
      this.search_list = [];
      this.current_page = 1;

      let reg = new RegExp(this.search_data);
      this.time_limit_log.forEach((ele) => {
        if (reg.test(ele.TYPE) || reg.test(ele.CONTENT) || reg.test(ele.OPERATOR)) {
          this.search_list.push(ele);
        }
      })
      this.current = this.search_list.length;
      this.current_device_data = this.search_list.slice(0, this.limit);
      this.current_device_data.forEach((ele) => {
        ele.TIME = dateFormatting(new Date(ele.TIME)) + ' ' + timeFormatting(
          new Date(ele.TIME));
      })
    },
    searchByDate() {
      if (this.selectDate != null) {
        if (this.endDate < this.startDate) {
          this.$msg({
            message: this.$t('schedule.endDateTips'),
            type: 'warning'
          });
        } else if (this.startDate < Number(this.minStartDate._d)) {
          this.$msg({
            message: this.$t('log.selectTips1'),
            type: 'warning'
          });
        } else {
          this.getZlogList(this.selecetedDevice);
        }
      } else {
        this.$msg({
          message: this.$t('log.searchTips1'),
          type: 'warning'
        });
      }
    },
    currentChange(val) {
      this.current_page = val;
      if (this.search_list.length != 0) {
        this.current_device_data = this.search_list.slice((val - 1) * this.limit, val * this.limit);
        this.current_device_data.forEach((ele) => {
          ele.TIME = dateFormatting(new Date(ele.TIME)) + ' ' + timeFormatting(new Date(ele.TIME));
        })
        this.loading = false;
      } else {
        this.current_device_data = this.time_limit_log.slice((val - 1) * this.limit, val * this.limit);
        this.current_device_data.forEach((ele) => {
          ele.TIME = dateFormatting(new Date(ele.TIME)) + ' ' + timeFormatting(new Date(ele.TIME));
        })
        this.loading = false;
      }
    },
    // getTerminalList(log) {
    //   this.$http.post("/admin/device/list", log, data => {
    //     this.deviceList = data.list ? data.list : [];
    //     this.device_total = data.count;
    //     this.device_count += data.list.length;
    //     this.deviceList.forEach(ele => {
    //       this.options.push({
    //         value: ele.id,
    //         label: ele.name,
    //         disabled: (ele.run_state == 0 ? true : false)
    //       })
    //       this.device_info_listt.push({
    //         id: ele.id,
    //         type_id: ele.type_id,
    //         sn: ele.sn,
    //         name: ele.name,
    //         cache: {}
    //       })
    //     })
    //   })
    // },
    async getDeviceList() {
      await this.$http.post("/admin/device/getDeviceNumber", { group_ids: this.groupIds }, data => {
        this.deviceCount = 0;
        data.runState.forEach(d => {
          this.deviceCount += d.number;
        });
      });
      await this.$http.post("/admin/device/list", { page: 1, group_ids: this.groupIds, limit: this.deviceCount }, data => {
        this.device_info_listt = data.list.map((d) => {
          const { id, type_id, sn, name } = d;
          return { id, type_id, sn, name, cache: {} };
        });
      });
    },
    getZlogList(data) {

      this.myWebSocket.onmessage = (val) => {
        this.device_total_log = JSON.parse(val.data).data.log;
        let starTime = this.startDate._d == undefined ? this.startDate : Number(this.startDate
          ._d);
        let endTime = this.endDate._d == undefined ? this.endDate : Number(this.endDate._d);
        this.device_total_log.forEach((ele) => {
          if (ele.TIME >= starTime && ele.TIME <= endTime) {
            this.time_limit_log.push(ele);
          }
        })
        this.current = this.time_limit_log.length;
        this.current_device_data = this.time_limit_log.slice(0, this.limit);
        this.current_device_data.forEach((ele) => {
          ele.TIME = dateFormatting(new Date(ele.TIME)) + ' ' + timeFormatting(
            new Date(ele.TIME));
        })
        this.loading = false;
      }

      this.loading = true;
      this.device_total_log = [];
      this.current_device_data = [];
      this.time_limit_log = [];
      this.current = 0;
      this.$http.post('/admin/command/zlog', {
        devices_info: uriEncode([data])
      }, () => {
      });
    },
    // loadMore() {
    //   const group_ids = sessionStorage.getItem('group_ids');
    //   if (this.device_count < this.device_total) {
    //     this.page += 1;
    //     this.getTerminalList({
    //       limit: this.limit,
    //       page: this.page,
    //       group_ids: group_ids
    //     })
    //   }
    // },
    exportExcel() {
      if (this.selectDate == null || this.time_limit_log.length == 0) {
        this.$msg({
          message: this.$t('log.searchTips1'),
          type: "warning"
        })
      } else {
        this.exportDialogVisible = true;
      }

    },
    closeExportDialog(isConfirm) {
      if (isConfirm) {
        //console.log("导出.....")
      }
      this.exportDialogVisible = false;
    }
  },
  computed: {
    myWebSocket() {
      return this.$store.getters.myWebSocket;
    },
  },
  created() {
    this.getDeviceList();
    // const group_ids = sessionStorage.getItem('group_ids');
    // this.getTerminalList({
    //   limit: this.limit,
    //   page: 1,
    //   keyword: '',
    //   group_ids: group_ids
    // });

  }
}
</script>

<style lang="scss" scoped>
.fontred {
  color: red;
}
.fontgreen {
  color: green;
}
.login-log {
  height: 100%;

  .choose_button {
    margin-left: 50%;
  }

  .topcon {
    display: flex;
    justify-content: space-between;
    padding: 1%;
    width: 100%;
    align-items: center;

    .pick {
      display: flex;
      align-items: center;
    }

    .pick span {
      white-space: nowrap;
    }

    .datepick {
      flex-basis: 26%;
      display: flex;
      height: 100%;
      background-color: #edfbff;
      border-radius: 30px;
    }
  }

  /deep/ .cell {
    font-size: 16px;
  }

  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: #2fb3ff;
    }
  }
}

// .right {
// 	display: flex;
// 	width: 35%;
// 	justify-content: space-between;
// }
.export {
  width: 40px;
  height: 40px;
  background-image: url(~@/assets/images/public/public_upload.png);
  background-size: 100%;
  background-position: center;
}

.c-u-left {
  display: flex;
  // background-color: orange;
  justify-content: space-between;
  width: 750px;
  align-items: center;
  margin-left: 0;
  .select {
    width: 200px;
  }
}

.picker {
  height: 20vh;
  position: relative;

  .content {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
  }
}

.export:hover {
  cursor: pointer;
}

.c-u-right {
  /deep/ .el-input__inner {
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
  }

  /deep/ .el-input__suffix {
    line-height: 30px;
    color: #2fb3ff;
    font-size: 16px;
    right: 10px;
  }
}

.pick /deep/ .el-date-editor {
  width: 150px;
  border-radius: 30px;
}

.pick /deep/ .el-input__inner {
  padding: 0 10px;
  border-radius: 15px;
}

.pick /deep/ .el-range-input:hover {
  cursor: pointer;
}

.pick /deep/ .el-range-separator {
  width: 30px;
  color: #c4e3f6;
}

.pick /deep/ .el-input__icon {
  display: none;
}

.select /deep/ .el-input__inner {
  border-radius: 15px;
}
</style>
